import type { Assignment } from '@/types'

export function formatAssignmentReference(
  assignment: { id: string | number; assignment_ref?: string | null },
) {
  const ref = assignment.assignment_ref?.trim()
  if (ref) {
    return ref
  }
  return `#${String(assignment.id).slice(0, 8)}`
}

export function resolveAssignmentReference(
  assignmentId: string | number | null | undefined,
  assignmentRef?: string | null,
) {
  if (!assignmentId) {
    return null
  }
  const ref = assignmentRef?.trim()
  if (ref) {
    return ref
  }
  return `#${String(assignmentId).slice(0, 8)}`
}

export function isDeclinedAssignmentStatus(status?: string | null) {
  return status === 'rejected' || status === 'auto_rejected'
}

export function assignmentHasDeclineChain(assignment: Assignment) {
  return Boolean(
    assignment.parent_assignment
    || assignment.follow_up_assignment_id
    || (isDeclinedAssignmentStatus(assignment.status) && (
      assignment.rejection_reason
      || assignment.declined_worker
      || assignment.declined_worker_name
    )),
  )
}

export function buildAssignmentDetailsPath(assignmentId: string | number) {
  return `/assignments/${assignmentId}/details`
}
